module.exports = __webpack_public_path__ + "static/img/single_good1.5e2c05f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/goods/single_good1.png
// module id = k6mw
// module chunks = 1